import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SwiperDirective } from './swiper/swiper.directive';
import { NoSpecialCharsDirective } from './no-special-chars/no-special-chars.directive';


@NgModule({
  declarations: [
    SwiperDirective,
    NoSpecialCharsDirective
  ],
  exports:[
    SwiperDirective,
    NoSpecialCharsDirective
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DirectivesModule { }
